import { useEffect, useState } from 'react';
import { useTable } from 'src/hooks/use-table';
import { NotificationsTable } from './table';
import { NotificationListFilter, NotificationsFilter } from './filter';
import { useNotifications } from 'src/hooks/query/notification/use-notifications';
import { ContentWrapper } from 'src/components/common/wrapper/content/wrapper';
import { FilterWrapper } from 'src/components/common/wrapper/filter/wrapper';
import { TableWrapper } from 'src/components/common/wrapper/table/wrapper';
import { MarkAllUnreadButton } from './mark-unread-button';
import { Can } from 'src/utils/can';
import {
  Actions,
  AppArea,
  NotificationPayload,
  NotificationsDocument,
  NotificationsUnreadCountDocument,
  SortingDirection,
  Subjects,
} from 'src/graphql/generated/graphql';

const PAGINATION_LIMIT = 20;

export const NotificationsList = () => {
  const { page, setPage, filter, onFilterChange, defaultFilter } = useTable<
    NotificationListFilter,
    Record<any, any>
  >({
    defaultFilter: {},
  });
  const referchDocuments = [
    NotificationsDocument,
    NotificationsUnreadCountDocument,
  ];
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    setPage(0);
  }, [setPage, filter]);

  const { loading, data } = useNotifications({
    filter: filter,
    page: page,
    pageLimit: PAGINATION_LIMIT,
    sorting: {
      createdAt: SortingDirection.Desc,
    },
    onCompleted: (data) =>
      setTotalCount(data?.notifications?.pagination?.totalCount),
  });

  const records = data?.records || [];

  return (
    <>
      <FilterWrapper>
        <NotificationsFilter
          onSubmit={onFilterChange}
          defaultFilter={defaultFilter}
        />
      </FilterWrapper>
      <ContentWrapper>
        <TableWrapper>
          <Can
            I={Actions.Write}
            a={Subjects.Notifications}
            appArea={AppArea.Common}
          >
            <div className="flex justify-end">
              <MarkAllUnreadButton refetchDocuments={referchDocuments} />
            </div>
          </Can>
          <NotificationsTable
            data={records as NotificationPayload[]}
            loading={loading}
            className="mt-4"
            refetchDocuments={referchDocuments}
            options={{
              page,
              count: totalCount,
              rowsPerPage: PAGINATION_LIMIT,
              onChangePage: setPage,
              enableNestedDataAccess: '.',
            }}
          />
        </TableWrapper>
      </ContentWrapper>
    </>
  );
};
